import styled from 'styled-components';
import { FlexCenter } from '@app.styled';
import { ModalProp } from '@types';

export const Wrapper = styled(FlexCenter)`
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1000 !important;
    align-content: center;
    background-color: rgba(0, 0, 0, 0.7);
`;

export const HeaderWrapper = styled.div`
    display: flex;
    height: 66px;
    background-color: #0a4a8d;
    color: #fff;
    border-radius: 5px;
    padding: 12px;
    align-items: center;
    justify-content: space-between;
`;

export const ContainerContentWrapper = styled.div`
    background-color: #fff;
`;

export const ContentWrapper = styled.div<ModalProp>`
    box-sizing: border-box;
    border: 2px solid #0a4a8d;
    border-radius: 5px;
    overflow: auto;
    max-height: 90%;
    max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : '25.063rem')};
    box-shadow: 5px 7px 6px 0 rgba(0, 0, 0, 0.16);

    @media screen and (max-width: 500px) {
        max-height: 27.5rem;
    }
`;

export const CloseIcon = styled.img`
    cursor: pointer;
    width: 30px;
    height: 30px;
    margin-left: -20px;
`;

export const HeaderText = styled.div`
    flex: 1;
    text-align: center;
`;
